import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthContext';
import UserDetailsCard from '../../User/UserDetailsCard/UserDetailsCard';

function UserProfilePage({
	get_user_endpoint,
	update_user_endpoint,
	get_subscriptions_by_user_endpoint,
	create_billing_portal_session_endpoint
}) {
	const { user, activeFitnessProfile } = useAuth();

	if (activeFitnessProfile?.id) {
		return <Navigate to="/fitness-hub" replace />;
	}

	return (
		<div className="container p-4 pt-4 lg:py-14 md:px-20">
			<UserDetailsCard
				userId={user.id}
				get_user_endpoint={get_user_endpoint}
				update_user_endpoint={update_user_endpoint}
				get_subscriptions_by_user_endpoint={get_subscriptions_by_user_endpoint}
				create_billing_portal_session_endpoint={
					create_billing_portal_session_endpoint
				}
			/>
		</div>
	);
}

export default UserProfilePage;
